/* global process */
import Vue from 'vue';

import axios from 'axios';
import '../vendor/lm';
import './utils/bodyWidth';

import router from './router/';
import store from './store/';
import registerBaseComponents from './components/';
import App from './App.vue';

import SvgVue from 'svg-vue';
import vueDebounce from 'vue-debounce';
import VueCookies from 'vue-cookies';
import VueMq from 'vue-mq';
import Toasted from 'vue-toasted';
import VueWait from 'vue-wait';

import { billingPlanFilter } from './utils/filters';
import usdFormatter from './utils/usdFormatter';
import { toastMessageContainer, toastSuccess, toastError, toastMessage, toastInfo } from './utils/toastsConfig';

registerBaseComponents();

axios.defaults.withCredentials = true;

Vue.filter('billingPlanFilter', billingPlanFilter);
Vue.filter('usdFormatter', usdFormatter);

Vue.prototype.$http = axios;
Vue.prototype.$appUrl = process.env.MIX_APP_URL;
Vue.prototype.$event = new Vue();

Vue.use(SvgVue);
Vue.use(vueDebounce, {
    listenTo: 'keyup',
});
Vue.use(VueCookies);
Vue.use(VueMq, {
    breakpoints: {
        sm: 500,
        other: Infinity,
    },
});
Vue.use(Toasted, {
    iconPack: 'fontawesome',
});

Vue.toasted.register('toast_success',
    toastMessageContainer,
    toastSuccess
);

Vue.toasted.register('toast_error',
    toastMessageContainer,
    toastError
);

Vue.toasted.register('toast_info',
    toastMessageContainer,
    toastInfo
);

Vue.toasted.register('toast_message',
    toastMessageContainer,
    toastMessage
);

Vue.use(VueWait);

if ('production' === process.env.NODE_ENV) {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
} else {
    Vue.config.productionTip = true;
}

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    wait: new VueWait({
        useVuex: true,
    }),
}).$mount('#app');
